import { render, staticRenderFns } from "./ErrorNoEnvFilePopup.vue?vue&type=template&id=9a86861a&scoped=true&"
import script from "./ErrorNoEnvFilePopup.vue?vue&type=script&lang=js&"
export * from "./ErrorNoEnvFilePopup.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNoEnvFilePopup.vue?vue&type=style&index=0&id=9a86861a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a86861a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VCol,VContainer,VDialog,VRow})
